import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentCacheContext = createContext({
  data: null,
  loading: true,
});

export const useSiteContentCache = () => useContext(SiteContentCacheContext);

/** Branded loading screen shown while CMS data is fetched */
export const SiteLoadingScreen = () => (
  <div className="min-h-screen bg-[#0C2E3C] flex items-center justify-center">
    <div className="text-center">
      <div className="w-12 h-12 border-2 border-[#C8E64E] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
      <p className="text-[#F0F4F3]/60 text-sm font-medium tracking-wider">LOADING...</p>
    </div>
  </div>
);

export const SiteContentCacheProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    try {
      const cached = sessionStorage.getItem("cfc_site_content");
      if (cached) return JSON.parse(cached);
    } catch (e) { console.warn("Failed to parse cached content:", e); }
    return null;
  });
  const [loading, setLoading] = useState(!data);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(`${API}/site-content/public`);
        setData(res.data);
        sessionStorage.setItem("cfc_site_content", JSON.stringify(res.data));
      } catch (e) {
        console.error("Failed to fetch site content:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  return (
    <SiteContentCacheContext.Provider value={{ data, loading }}>
      {children}
    </SiteContentCacheContext.Provider>
  );
};
